"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityMapLayout = exports.EntityMapLayoutDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_app_layout_1 = require("../../hooks/use-app-layout");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../hooks/use-icons");
var client_1 = require("@apollo/client");
var entity_search_toggles_1 = require("./entity-search-toggles");
var entity_map_1 = require("./entity-map");
var entity_type_title_1 = require("./entity-type-title");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var map_state_context_1 = require("../context/map-state-context");
exports.EntityMapLayoutDefaultProps = {
  minZoom: 0.8,
  maxZoom: 6.3
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #FFF;\n    overflow: hidden;\n    position: fixed;\n    padding: ", ";\n    box-sizing: border-box;\n  "], ["\n    background: #FFF;\n    overflow: hidden;\n    position: fixed;\n    padding: ", ";\n    box-sizing: border-box;\n  "])), theme_1.theme.UNIT(3))
});
var MapStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FilterControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    left: ", ";\n  "], ["\n    left: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var TogglesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2.5))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    \n  "], ["\n    padding: ", ";\n    \n  "])), theme_1.theme.UNIT(2))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Banner: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Title: (0, styled_components_1.default)(entity_type_title_1.EntityTypeTitle)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled_components_1.default.p(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  FilterControls: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FilterControlsStyles),
  Toggles: (0, styled_components_1.default)(entity_search_toggles_1.EntitySearchToggles)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TogglesStyles),
  Map: (0, styled_components_1.default)(entity_map_1.EntityMap)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MapStyles)
};
var EntityMapLayout = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    minZoom = props.minZoom,
    maxZoom = props.maxZoom;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var list = definition.list;
  var useActive = definition.useActive;
  var filterValue = useActive ? {
    isActive: {
      is: true
    }
  } : {};
  var _a = __read((0, react_1.useState)(filterValue), 2),
    filter = _a[0],
    setFilter = _a[1];
  if (!definition) {
    throw new Error("Entity definition for ".concat(entityTypeName, " not found"));
  }
  var defaultData = {};
  var queryFieldName = list.queryFieldName;
  var _b = (0, client_1.useQuery)(definition.map.query, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: {
        filter: filter,
        skip: 0
      }
    }),
    _c = _b.data,
    data = _c === void 0 ? defaultData : _c,
    error = _b.error,
    loading = _b.loading;
  var results = data[queryFieldName] && data[queryFieldName].results || [];
  var resultsWithCoordinates = results.filter(function (result) {
    return !!result.latitude && !!result.longitude;
  });
  var _d = __read((0, use_dimensions_1.useDimensions)(), 2),
    bannerRef = _d[0],
    height = _d[1].height;
  var Icons = (0, use_icons_1.useIcons)();
  var _e = (0, use_app_layout_1.useAppLayout)(),
    availableHeight = _e.availableHeight,
    availableWidth = _e.availableWidth;
  var handleToggleChange = function (value) {
    setFilter(value);
  };
  var initialMapState = {
    isVisible: false,
    isInitialized: false,
    zoom: 2,
    latitude: -5.441022303718128,
    longitude: 117.59765625000352
  };
  return react_1.default.createElement(map_state_context_1.MapStateProvider, {
    value: initialMapState
  }, react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Banner, {
    ref: bannerRef
  }, react_1.default.createElement(My.Title, {
    entityTypeName: entityTypeName
  }), react_1.default.createElement(My.Description, null, definition.map.description)), react_1.default.createElement(My.Map, {
    zoom: 2,
    width: "".concat(availableWidth - 24, "px"),
    height: "".concat(availableHeight - (height || 0) - 24, "px"),
    loading: loading,
    entityTypeName: entityTypeName,
    items: resultsWithCoordinates
  })));
};
exports.EntityMapLayout = EntityMapLayout;
exports.EntityMapLayout.defaultProps = exports.EntityMapLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;